import { Component, input, model } from '@angular/core';

@Component({
  selector: 'app-tab',
  template: `
    <div [hidden]="!active()"
         [attr.aria-selected]="active()"
         [attr.aria-controls]="tabTitle()"
         id="{{ tabId() }}"
         class="tab-pane">
      <ng-content></ng-content>
    </div>
  `,
})
export class TabComponent {
  readonly tabTitle = input.required<string>();
  readonly tabId = input.required<string>();
  readonly active = model<boolean>(false);
  readonly autoWidth = input<boolean>(false);
}
